import { BaseModel } from '../../../models/base-model'
import { ExplanationType, Question } from '../'

const EXPLANATION_TYPES = {
  TEXT: '1',
  VIDEO: '2'
}

export class Explanation extends BaseModel {
  public name: string
  public value: string
  public question: Question
  public explanationType: ExplanationType

  public isVideoExplanation() {
    return this._isExplanationOfType(EXPLANATION_TYPES.VIDEO)
  }

  public isTextExplanation() {
    return this._isExplanationOfType(EXPLANATION_TYPES.TEXT)
  }

  private _isExplanationOfType(typeId: string) {
    return (this.explanationType || {id: ''}).id === typeId
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/explanation/explanation.ts